import { useMutation } from '@apollo/client';
import { Mutation } from 'graphql/generated/graphqlTypes';
import { GO_BACK_ONE_ONBOARDING_STEP } from 'graphql/mutations';
import { GET_CURRENT_TENANT } from 'graphql/queries';
import { useEffect } from 'react';
import { BaseHookProps } from 'v2/hooks/hooks.types';

const useGoBackOneOnboardingStep = ({ handleFetchError }: BaseHookProps) => {
  const [goBackOneOnboardingStepMutation, { loading, error }] = useMutation<
    Pick<Mutation, 'goBackOneOnboardingStep'>,
    null
  >(GO_BACK_ONE_ONBOARDING_STEP, {
    refetchQueries: [{ query: GET_CURRENT_TENANT }],
    awaitRefetchQueries: true
  });

  useEffect(() => {
    if (error) {
      handleFetchError('Error while going back one step');
      console.error(error);
    }
  }, [error]);

  const goBackOneOnboardingStep = async () => {
    const result = await goBackOneOnboardingStepMutation();
    return result;
  };

  return {
    loading,
    goBackOneOnboardingStep
  };
};

export default useGoBackOneOnboardingStep;
